﻿{
  "boardmakerHome": "Boardmaker Home",
  "subscription": "Subskrypcja",
  "change": "Zmień",
  "currency": "USD",
  "save": "Zaoszczędź",
  "save17Percent": "<strong>Zaoszczędź {{percent}}%</strong> z planem rocznym",
  "save17PercentNoBold": "Zaoszczędź {{percent}}%",
  "yearly": "Roczna",
  "monthly": "Miesięczna",
  "Lifetime": "Bez ograniczeń",
  "PerMonth": "Na miesiąc",
  "PerYear": "Na rok",
  "Free": "Bezpłatnie",
  "optional": "opcjonalne",
  "trialLengthTrial": "<0>{{ trialLength }}</0>-dniowa wersja próbna",
  "viewAllPlans": "Pokaż wszystkie plany",
  "myBoardmaker": "My Boardmaker",
  "canada": "Kanada",
  "unitedStates": "Stany Zjednoczone",
  "oneMomentPlease": "Proszę czekać...",
  "software": "Oprogramowanie",
  "boardmakerStudio": "Boardmaker Studio",
  "boardmakerStudentCenter": "Boardmaker Student Center",
  "complete": "Ukończono",
  "loadingRegions": "Wczytywanie dostępnych regionów",
  "loadingPartners": "Wczytywanie dostępnych partnerów",
  "supportedPeripherals": "Obsługiwane urządzenia peryferyjne",
  "pleaseWait": "Proszę czekać...",
  "minimum": "Minimalne",
  "recommended": "Zalecane",
  "browser": "Przeglądarka",
  "tobiiDynavoxEyeTrackers": "Urządzenia Tobii Dynavox Eye Tracker",
  "boardmaker7": "Boardmaker 7",
  "needHelpChoosing": "potrzebna pomoc w wybraniu",
  "or": "lub",
  "advantages": "Korzyści",
  "visitPartnerSite": "Odwiedź witrynę partnera",
  "recentOrders": "Najnowsze zamówienia",
  "current": "bieżące",
  "orLater": "lub późniejsze",
  "customerSupport": "pomoc dla klientów",
  "proratedAmount": "Proporcjonalna ilość",
  "community": {
    "community": "Społeczność",
    "getStartedNow": "Rozpocznij teraz!"
  },
  "personal": "Subskrypcja osobista",
  "professional": "Subskrypcja profesjonalisty",
  "planCard": {
    "noCCRequired": "Karta kredytowa nie jest wymagana",
    "cCOnly": "Tylko z użyciem karty kredytowej",
    "cCOrPO": "Karta kredytowa lub zamówienie zakupu",
    "myPlan": "Mój plan",
    "currentPlan": "Bieżący plan",
    "downgradeNotice": "Zmiana zostanie wprowadzona po wygaśnięciu bieżącego planu.",
    "upgradeNotice": "Zmiana nastąpi natychmiast."
  },
  "selectedPlanSummary": {
    "summary": "Podsumowanie",
    "change": "$t(change)",
    "subtotal": "Podsuma"
  },
  "action": {
    "joinToday": "Dołącz dziś!",
    "finish": "Zakończ",
    "subscribe": "Subskrybuj",
    "resubscribe": "Subskrybuj ponownie",
    "requestAQuote": "Poproś o wycenę",
    "try": "Wypróbuj",
    "startTrial": "Rozpocznij wersję próbną",
    "buyNow": "Kup teraz",
    "tryIt": "Wypróbuj to",
    "tryItFree": "Wypróbuj przez 30 dni!",
    "free": "bezpłatnie",
    "getStarted": "Rozpocznij",
    "forTrialDays": "przez <1>{{trialLength}}</1> dni",
    "comparePlans": "Porównaj plany",
    "hideComparisons": "Ukryj porównania",
    "learnMore": "Więcej informacji",
    "start": "Start",
    "next": "Dalej",
    "edit": "Edytuj",
    "cancel": "Anuluj",
    "imTaxExempt": "Zwolnienie z opodatkowania",
    "submit": "Prześlij",
    "print": "Drukuj",
    "backToPaymentDetails": "Powrót do szczegółów płatności",
    "close": "Zamknij",
    "back": "Wstecz",
    "continue": "Kontynuuj",
    "uploading": "Przesyłanie",
    "delete": "Usuń",
    "update": "Aktualizuj",
    "generatingInvoice": "Tworzenie faktury",
    "proceed": "Kontynuuj",
    "modify": "Zmień",
    "yes": "Tak",
    "signUp": "Zarejestruj się",
    "downloads": "Pliki do pobrania"
  },
  "status": {
    "loading": "Wczytywanie...",
    "creatingAccount": "Tworzenie konta...",
    "submitting": "Przesyłanie...",
    "submittingPayment": "Przesyłanie płatności...",
    "submittingRequest": "Przesyłanie zamówienia..."
  },
  "planComparison": {
    "label": "Jakie korzyści wiążą się z każdym planem?",
    "buttonShow": "$t(action.comparePlans)",
    "buttonHide": "$t(action.hideComparisons)",
    "header": "Porównanie cech i funkcji",
    "subheader": "Najchętniej wybierane na świecie rozwiązanie do tworzenia niekończącej się komunikacji obrazkowej i materiałów wizualnych!"
  },
  "account": {
    "email": "E-mail",
    "accountFoundTitle": "Odnaleziono konto",
    "accountFoundMessage": "Istnieje już konto z takim adresem e-mail. Czy chcesz zalogować się, używając tego konta, czy wolisz użyć innego adresu e-mail i utworzyć nowe konto?",
    "signedOutElsewhereTitle": "Zostałeś wylogowany",
    "signedOutElsewhereMessage": "Zostałeś wylogowany w innej karcie. Zaloguj się ponownie, aby kontynuować, lub zamknij ten komunikat, aby przeglądać bez konta.",
    "signedOutElsewhereDismiss": "Kontynuuj przeglądanie",
    "federatedEmailTitle": "Wykryto adres e-mail organizacji",
    "federatedEmailMessage": "Ten adres e-mail korzysta z logowania Twojej organizacji. Zaloguj się, aby uzyskać dostęp do Boardmakera przez swoją organizację, lub użyj innego adresu e-mail, aby utworzyć nowe konto.",
    "federatedEmailUseDifferent": "Użyj innego adresu e-mail",
    "logIn": "Logowanie",
    "logOut": "Wyloguj",
    "loggingIn": "Logowanie...",
    "loggingOut": "Wylogowywanie...",
    "verifying": "Weryfikowanie...",
    "loggingInMessage": "Trwa logowanie...",
    "createAccount": "Utwórz konto",
    "creatingAccount": "$t(status.creatingAccount)",
    "login1": "Masz już ",
    "login2": "Tobii Dynavox",
    "login3": "konto",
    "loginPrompt": "Masz już <1>konto Tobii Dynavox</1>? <3>Zaloguj</3>",
    "cancelSubscription": "Anuluj subskrypcję",
    "areYouSure": "Czy na pewno chcesz wybrać ten plan? Kontynuowanie spowoduje następujące działania:",
    "cancelSubscriptionProcess": "Anuluj proces subskrypcji (bieżące postępy zostaną utracone)",
    "changeToCommunityPlan": "Zmień konto na plan społeczności",
    "onceYouveCompletedYourProfile": "Po wypełnieniu profilu, jeśli zdecydujesz się na uaktualnienie planu, możesz to uczynić w dowolnej chwili w sekcji Moje konto.",
    "proceed": "$t(action.proceed)",
    "back": "$t(action.back)",
    "loadingUser": "Pobieranie danych użytkownika"
  },
  "requestaquote": {
    "fillOutDetailsBelow": "Wypełnij poniższe dane, a nasz pracownik wkrótce się z Tobą skontaktuje.",
    "fillOutDetailsBelowLicense": "Wypełnij poniższe dane, a nasz doradca wkrótce się z Tobą skontaktuje."
  },
  "forms": {
    "confirmEmail": "Potwierdź adres e-mail",
    "billingDetails": "Dane do rozliczenia",
    "paymentType": "Forma płatności",
    "creditCardType": "Forma płatności",
    "creditCard": "Karta kredytowa",
    "purchaseOrder": "Zamówienie zakupu",
    "cardNumber": "Numer karty",
    "expirationDate": "Data wygaśnięcia",
    "cardholderName": "Nazwisko posiadacza karty",
    "cardSecurityCode": "Kod bezpieczeństwa karty",
    "securityCode": "Kod bezpieczeństwa",
    "organizationName": "Nazwa organizacji",
    "accountsPayableEmail": "Adres e-mail dla należności",
    "firstName": "Imię",
    "lastName": "Nazwisko",
    "addressLine": "Wiersz adresu 1",
    "addressLine2": "Wiersz adresu 2",
    "country": "Kraj",
    "language": "Język",
    "city": "Miejscowość",
    "stateProvinceRegion": "Kraj / województwo / region",
    "zipPostalCode": "Kod pocztowy",
    "month": "Miesiąc",
    "year": "Rok",
    "optional": "opcjonalne",
    "username": "Nazwa użytkownika",
    "name": "Nazwa",
    "phoneNumber": "Numer telefonu",
    "phone": "Telefon",
    "email": "E-mail",
    "url": "Strona internetowa",
    "selectYourCountry": "Wybierz kraj",
    "selectYourState": "Wybierz stan",
    "selectYourProvinceTerritory": "Wybierz województwo lub obszar",
    "selectYourTerm": "Wybierz okres",
    "1year": "1 rok",
    "2years": "2 lat",
    "3years": "3 lat",
    "4years": "4 lat",
    "5years": "5 lat",
    "instructorLogins": "Liczba loginów instruktora",
    "studentLogins": "Liczba loginów ucznia",
    "term": "Okres",
    "tradeIn": "Spełniasz warunek uzyskania obniżki?",
    "legacyVersions": "Czy korzystasz ze starszych wersji Boardmaker, aby uzyskać obniżkę ceny dla myBoardmaker?",
    "selectAResponse": "Wybierz odpowiedź",
    "yes": "Tak",
    "no": "Nie",
    "notSure": "Nie wiem",
    "password": "Hasło",
    "confirmPassword": "Potwierdź hasło",
    "additionalInformationOrQuestions": "Dodatkowe informacje lub pytania",
    "countryNotSupported": "---",
    "uploadDocument": "Prześlij dokument",
    "chooseFile": "Wybierz plik",
    "paymentMethod": "Forma płatności",
    "purchaseOrdersAreOnlyProcessed": "Zamówienia zakupu są przetwarzane dopiero po przesłaniu zamówienia, dlatego można je wcześniej modyfikować.",
    "PONumber": "Numer zamówienia zakupu",
    "PONotes": "Uwagi o organizacji",
    "iVerifyThatImAuthorized": "Potwierdzam, że posiadam upoważnienie do przesłania tego zamówienia zakupu.",
    "submissionSuccessful": "Pomyślnie przesłano!",
    "thankYourForYourRequest": "Dziękujemy za zamówienie! Wkrótce skontaktuje się z Tobą nasz pracownik.",
    "ccExpDateFormat": "MM/RRRR",
    "numberOfLicenses": "Liczba licencji",
    "pleaseEnterYourName": "Wpisz dokładnie swoje imię i nazwisko, tak jak widnieje na karcie",
    "needHelpFindingSecurityCode": "Potrzebna pomoc w znalezieniu kodu bezpieczeństwa na karcie?"
  },
  "validation": {
    "required": "Wymagane",
    "invalidEmail": "Nieprawidłowy adres e-mail",
    "emailsMustMatch": "Adresy e-mail muszą się zgadzać",
    "passwordsMustMatch": "Hasła muszą się zgadzać",
    "errorOccurred": "Wystąpił błąd podczas przesyłania formularza",
    "tryAgain": "Spróbuj ponownie. Jeśli problem nie ustąpi, skontaktuj się z pomocą techniczną.",
    "errorOccurredPDF": "Wystąpił błąd podczas wczytywania faktury (PDF)",
    "password": {
      "minLength": "Hasło musi zawierać co najmniej 8 znaków",
      "tooShort": "Zbyt krótkie",
      "checking": "Sprawdzanie..."
    },
    "USZipCode": "Wymagane wprowadzenie kodu pocztowego USA",
    "CAZipCode": "Wymagane wprowadzenie kodu pocztowego stanu Kalifornia",
    "invalidCardNumber": "Nieprawidłowy numer karty",
    "invalidCardType": "Nieprawidłowy rodzaj karty",
    "invalidExpirationDate": "Nieprawidłowa data wygaśnięcia",
    "invalidSecurityCode": "Nieprawidłowy kod bezpieczeństwa",
    "securityCodeNumericWarning": "Kod bezpieczeństwa może zawierać tylko cyfry",
    "invalidUsernameWarning": "Nieprawidłowa nazwa użytkownika. Dozwolone są litery lub cyfry.",
    "usernameMaxLengthWarning": "Nazwa użytkownika nie może przekraczać 60 znaków długości",
    "badZip": "Wpisany kod ZIP nie jest prawidłowy dla wybranego stanu.",
    "badPostalCode": "Wpisany kod pocztowy nie jest prawidłowy dla wybranego województwa lub obszaru.",
    "canadianAddressNeedsCad": "Kanadyjskie adresy rozliczeniowe są rozliczane w dolarach kanadyjskich. Aby kontynuować, wybierz flagę u góry strony, a następnie Kanadę."
  },
  "invoice": {
    "communityHeader": "Karta kredytowa nie jest wymagana. Bezpłatny dostęp do społeczności myBoardmaker Community. Zachowaj swoje dane i postępy, jeśli zdecydujesz się na uaktualnienie do płatnej subskrypcji. Na co czekasz?",
    "trialHeader": "Żadnych ograniczeń. Karta kredytowa nie jest wymagana. Zachowaj swoje dane i postępy, jeśli zdecydujesz się skonwertować wersję próbną do płatnej subskrypcji. Na co czekasz?",
    "plan": "Plan",
    "term": "Okres",
    "price": "Cena",
    "billingDetails": "$t(forms.billingDetails)",
    "paymentDetails": "Szczegóły płatności",
    "endingWith": "Kończy się",
    "expires": "Wygasa",
    "orderSummary": "Podsumowanie zamówienia",
    "orderDate": "Data zamówienia",
    "orderNumber": "Numer zamówienia",
    "subtotal": "$t(selectedPlanSummary.subtotal)",
    "tax": "Podatek",
    "total": "Suma",
    "aConfirmationEmail": "Wysłano potwierdzenie e-mail pod adres",
    "printOrderSummary": "Drukuj podsumowanie zamówienia",
    "recurringPaymentDisclaimer": "Twoje zamówienie obejmuje <strong>powtarzającą się płatność</strong> w kwocie <3>{{amount}}</3>, która pozwoli odnowić <5>{{date, LL}}</5>.",
    "firstPaymentDisclaimer": "Pobierzemy opłatę w wysokości <strong>{{amount}}</strong> <strong>{{date}}</strong>, gdy rozpocznie się nowy plan.",
    "PODisclaimer": "Twoja subskrypcja jest teraz aktywna i gotowa do użycia. Aby uniknąć zakłóceń w świadczeniu usługi, musimy otrzymać płatność w ciągu <strong>30 dni</strong>. Jeśli płatność nie zostanie odebrana do <4>{{date, LL}}</4>, Twoje konto zostanie skonwertowane na bezpłatne konto społeczności, aż do momentu opłacenia należności.",
    "purchaseOrderNumber": "Numer zamówienia zakupu",
    "orgNotes": "Uwagi o organizacji",
    "pleaseSendACopyOfYourInvoice": "Wyślij płatność i kopię faktury pod adres:",
    "ifYourPurchaseOrdersReady": "Jeśli Twoje zamówienie zakupu jest gotowe, możesz je teraz przesłać.",
    "supportedFileTypes": "Obsługiwane typy plików: .pdf, .jpg, .jpeg, .tif, .tiff, .png",
    "whenTheTimeComes": " W odpowiednim momencie prześlemy wiadomość e-mail pod adres <1>{{email}}</1> z przypomnieniem o następnej wymaganej płatności.",
    "uploadSuccessful": "Przesłano pomyślnie!",
    "yourAccountWillContinue": "Dziękujemy za złożenie zamówienia. W celu odnowienia subskrypcji należy odczekać 14 dni na przetworzenie zamówienia. Po zakończeniu zostanie wysłana wiadomość e-mail z potwierdzeniem zamówienia i fakturą.",
    "billing": "Adres rozliczeniowy",
    "payment": "Metoda płatności",
    "ifYourPurchaseOrderIsReady": "Jeśli Twoje zamówienie zakupu jest gotowe, możesz je teraz przesłać.",
    "PODisclaimer1": "Twoja subskrypcja jest teraz aktywna i gotowa do użycia.",
    "PODisclaimer2": "Płatność musi do nas dotrzeć w ciągu 30 dni, w przeciwnym razie Twoje konto zostanie automatycznie skonwertowane na bezpłatne konto społeczności.",
    "POStartsLaterDisclaimer": "Wyślemy fakturę <strong>{{date}}</strong>, gdy rozpocznie się nowy plan. Płatność jest wymagana w ciągu 30 dni od tej daty."
  },
  "legal": {
    "privacyPolicy": "Polityka prywatności",
    "studentPolicy": "Polityka dotycząca danych uczniów",
    "termsAndConditions": "Warunki korzystania",
    "termsOfService": "Zasady świadczenia usługi",
    "tdTermsAndConditions": "Wyrażam zgodę na <1>$t(legal.termsAndConditions) Tobii Dynavox</1>",
    "contactUs": "Kontakt z nami"
  },
  "errors": {
    "error": "Błąd",
    "loadingPlans": "Wczytywanie planów",
    "sorry": "Przepraszam... to nasza wina",
    "somethingWentWrong": "Wystąpił problem w naszym systemie. Zarejestrowaliśmy ten błąd i zachęcamy do kliknięcia <1>{{link}}</1>, jeśli problem wystąpi ponownie.",
    "tryGoingBack": "Spróbuj powrócić lub <1>{{link}}</1>",
    "downloadList": "Nie udało się wczytać listy plików do pobrania."
  },
  "404": {
    "sorry": "Przepraszamy... nie udało się odnaleźć tej strony.",
    "oldLink": "Łącze mogło utracić ważność lub strona została przeniesiona.",
    "tryGoingBack": "$t(errors.tryGoingBack)"
  },
  "trial": {
    "getStartedNow": "Rozpocznij bezpłatny okres próbny teraz!",
    "startYourFreeTrial": "Rozpocznij bezpłatny okres próbny",
    "todayWhichIncludesAccessForThirtyDays": " dzisiaj, co obejmuje dostęp przez 30 dni!"
  },
  "navigation": {
    "bmoRedirect": "Nastąpi przekierowanie do myBoardmaker..."
  },
  "expired": {
    "expiredTrialText": "Mamy nadzieję, że 30-dniowa wersja próbna bez ograniczeń okazała się przydatna. Twoja wersja próbna została skonwertowana na bezpłatny plan społeczności, a wszystkie Twoje dane i postępy* zostały zapisane. Aby uzyskać dostęp do funkcji Premium dostępnych w wersji próbnej, dokonaj uaktualnienia do subskrypcji miesięcznej lub rocznej.",
    "dataAndProgress": "* Dane i postępy zawarte w funkcjach Premium są dostępne tylko po opłaceniu pełnej subskrypcji."
  },
  "currencySelector": {
    "header": "Wybierz swój kraj i język",
    "disclaimer": {
      "USD": "Jeśli Twojego kraju nie ma na liście, wybierz Stany Zjednoczone"
    }
  },
  "taxExempt": {
    "us&ca": "Tylko Stany Zjednoczone i Kanada",
    "taxExemptionProgram": "Prześlij dokumenty potwierdzające zwolnienie z opodatkowania, używając tego formularza. Skontaktujemy się z Tobą przez pocztę e-mail w ciągu trzech dni roboczych, aby potwierdzić status zwolnienia od opodatkowania. Po otrzymaniu wiadomości e-mail z potwierdzeniem możesz złożyć zamówienie bez opłacania podatku. Jeśli zamówienie zostanie złożone przed otrzymaniem wiadomości e-mail z potwierdzeniem, zostanie naliczony podatek niepodlegający zwrotowi.",
    "taxExemptionProgramExisting": "Prześlij dokumenty potwierdzające zwolnienie z opodatkowania, używając tego formularza. Skontaktujemy się z Tobą przez pocztę e-mail w ciągu trzech dni roboczych, aby potwierdzić status zwolnienia od opodatkowania. Po otrzymaniu wiadomości e-mail z potwierdzeniem wszystkie dalsze zakupy i odnowienia subskrypcji będą zwolnione z podatku. Kwoty podatku doliczone do zakupów przed otrzymaniem wiadomości e-mail z potwierdzeniem zwolnienia od opodatkowania nie podlegają zwrotowi.",
    "yourSubmissionWasSuccessfulNew": "Pomyślnie przesłano. Nasz pracownik zapozna się z Twoją dokumentacją, a w ciągu trzech dni roboczych otrzymasz wiadomość e-mail z potwierdzeniem przetworzenia wniosku. Po zaakceptowaniu wniosku możesz złożyć zamówienie bez opłacania podatku. W międzyczasie utworzyliśmy dla Ciebie bezpłatne konto społeczności, aby umożliwić Ci odkrywanie wszystkich funkcji myBoardmaker.",
    "yourSubmissionWasSuccessfulExisting": "Pomyślnie przesłano. Nasz pracownik zapozna się z Twoją dokumentacją, a w ciągu trzech dni roboczych otrzymasz wiadomość e-mail z potwierdzeniem przetworzenia wniosku. Po zaakceptowaniu wniosku możesz dokonać kolejnej płatności bez opłacania podatku."
  },
  "modify": {
    "contactCustomerSupport": "Skontaktuj się z <1>{{supportLink}}</1>, aby zmienić swoją subskrypcję",
    "billingDetails": "Zmień szczegóły rozliczenia",
    "paymentModalHeader": "Pomyślnie zaktualizowano!",
    "paymentModalBody": "Twoje zmiany zostaną uwzględnione przy kolejnym cyklu rozliczeniowym.",
    "thankYou": "Dziękujemy za dokonanie płatności!",
    "daysRemaining": "dni pozostało",
    "dueDisclaimer": "Jeśli płatność nie zostanie odebrana w ciągu 30 dni od daty odnowienia, Twoje konto zostanie skonwertowane na bezpłatne konto społeczności, aż do momentu opłacenia należności.",
    "lateDisclaimer": "Aby uniknąć zakłóceń w subskrypcji, prosimy o uiszczenie pełnej należności. Jeśli płatność nie zostanie odebrana, Twoje konto zostanie skonwertowane na bezpłatne konto społeczności, aż do momentu opłacenia należności.",
    "nextPaymentDueIn": "Termin następnej płatności za",
    "days": "dni",
    "paymentIs": "Termin płatności wypadał",
    "daysPastDue": "dni temu",
    "recurringPaymentDisclaimer": "Twoje zamówienie <1>planOrOrder</1> obejmuje <strong>powtarzającą się płatność</strong> w kwocie <4>{{amount}}</4>, która pozwoli odnowić <7>{{date, LL}}</7>.",
    "recurringPaymentDisclaimerNoPrice": "Twój plan obejmuje <strong>powtarzającą się płatność</strong>, która odnowi się <3>{{date, LL}}</3>.",
    "pastDueDisclaimer": "Możesz przesłać zamówienie zakupu, używając jednej z poniższych form. Aby reaktywować subskrypcję, skontaktuj się z naszym działem obsługi klienta.",
    "yourAccountHasBeenConverted": "Twoje płatne konto zostało skonwertowane na bezpłatne konto społeczności",
    "balanceDueIn": "Termin płatności za",
    "subscriptionExpiresIn": "Subskrypcja wygaśnie za",
    "paymentPastDue": "Minął termin płatności",
    "autoRenewal": "Automatyczne odnawianie",
    "turnAutoRenewOff": {
      "header": "Wyłącz automatyczne odnawianie subskrypcji",
      "areYouSure": "Czy na pewno chcesz wyłączyć automatyczne odnawianie? Kontynuowanie spowoduje następujące działania:",
      "points": [
        "Anuluj płatną subskrypcję na końcu bieżącego cyklu rozliczeniowego.",
        "Skonwertuj konto na bezpłatny plan społeczności na końcu bieżącego cyklu rozliczeniowego.",
        "Uzyskasz dostęp do swojej zawartości po konwersji konta, a w dowolnej chwili możesz ponownie dokonać subskrypcji, aby odzyskać dostęp do funkcji Premium, które oferuje płatna subskrypcja. ",
        "Jeśli przed upływem bieżącej subskrypcji zmienisz zdanie, ponownie włącz automatyczne odnawianie."
      ],
      "footer": "Czy chcesz wyłączyć automatyczne odnawianie?"
    },
    "turnAutoRenewOn": {
      "header": "Włącz automatyczne odnawianie subskrypcji",
      "areYouSure": "Automatyczne odnawianie subskrypcji obejmuje:",
      "points": [
        "Twoja subskrypcja odnowi się teraz automatycznie po upływie bieżącego okresu subskrypcji.",
        "Płatność bez problemów za pomocą zapisanej formy płatności.",
        "Wyślemy na Twoje konto e-mail pokwitowanie po każdym odnowieniu subskrypcji.",
        "Jak zawsze, możesz w dowolnej chwili zmienić ustawienia subskrypcji w sekcji Szczegóły mojego planu.",
        "Zmieniasz zdanie? Wyłącz automatyczne odnawianie przed końcem ostatniego dnia bieżącego okresu subskrypcji, aby uniknąć naliczenia opłaty."
      ],
      "footer": "Czy chcesz włączyć automatyczne odnawianie?"
    },
    "on": "Włącz",
    "off": "Wyłącz",
    "pending": "oczekujące",
    "plan": "Plan",
    "term": "Okres",
    "effective": "Obowiązuje",
    "subscription": "Subskrypcja",
    "downgradeWarning": {
      "title": "Obniżenie statusu subskrypcji",
      "prompt": "Czy na pewno chcesz wybrać ten plan? Kontynuowanie spowoduje następujące działania:",
      "planChange": "Zmień swój plan z Subskrypcji profesjonalisty na Subskrypcję osobistą na końcu bieżącego cyklu rozliczeniowego",
      "termChange": "Zmień okres subskrypcji z rocznego na miesięczny na końcu bieżącego cyklu rozliczeniowego",
      "changeNote": "Twoje zmiany zostaną uwzględnione przy kolejnym cyklu rozliczeniowym.",
      "termChangeMultiToYearly": "Zmień okres subskrypcji z wieloletniego na roczny na końcu bieżącego cyklu rozliczeniowego",
      "termChangeMultiToMonthly": "Zmień okres subskrypcji z wieloletniego na miesięczny na końcu bieżącego cyklu rozliczeniowego"
    },
    "futureAmendmentThankYou": "Zmiany te zostaną wprowadzone na koniec bieżącego cyklu rozliczeniowego. Faktura stanie się dostępna po wprowadzeniu zmian do Twojego konta. Jeśli chcesz anulować oczekującą zmianę, skontaktuj się z <1>działem obsługi klienta</1>.",
    "futureAmendmentDisclaimer": "Twój bieżący plan <1>{{planName}}</1> wygaśnie w dniu <3>{{startEndDate}}</3>. Twój nowy plan <5>{{selectedPlanName}}</5> rozpocznie się w dniu <7>{{startEndDate}}</7> i automatyczne odnowi <9>{{term}}</9>.",
    "modificationPending": "Oczekiwanie na zmianę planu",
    "paymentDeclined": "Twoja transakcja odnowienia subskrypcji została odrzucona. Zmień formę płatności do dnia <1>{{date}}</1>, w przeciwnym razie subskrypcja zostanie anulowana.",
    "continueSubscription": "Twoja subskrypcja zakończy się w dniu <1>{{ date1 }}</1>. Jeśli chcesz kontynuować subskrypcję przez następny {{term}},, włącz automatyczne odnawianie do <5>{{ date2 }}</5>, a przetworzymy Twoją płatność następnego dnia.",
    "discontinuedRatePlan": "Twój bieżący plan subskrypcji nie jest już dostępny. Wybierz inną opcję.",
    "cancelYourSubscription": "Jeśli chcesz anulować subskrypcję i otrzymać pełny zwrot kosztów, skontaktuj się z <1>{{supportLink}}</1> przed <3>{{thirtyDayWindow}}</3>",
    "modifySubscription": "Zmień subskrypcję",
    "cancelCardText": "Możesz anulować subskrypcję w dowolnym momencie. Ale będzie nam miło, jeśli zostaniesz z nami.",
    "cancelConfirmTitle": "Czy na pewno chcesz anulować subskrypcję?",
    "cancelConfirmIntro": "Twój bieżący plan pozostanie aktywny do <strong>{{date}}</strong>. Po zakończeniu planu:",
    "cancelConsequences": [
      "Utracisz dostęp do funkcji premium.",
      "Stracisz ekskluzywne korzyści dostępne w ramach subskrypcji.",
      "Korzyści z subskrypcji zakończą się wraz z wygaśnięciem bieżącego planu."
    ],
    "keepSubscription": "Zachowaj moją subskrypcję",
    "confirmCancel": "Nie, chcę anulować",
    "cancelledTitle": "Twoja subskrypcja została anulowana!",
    "cancelledBody": "Twoja subskrypcja została anulowana. Po {{date}} nie będziesz mieć dostępu do konta premium.",
    "cancelledFarewell": "Szkoda, że odchodzisz! Zawsze możesz do nas wrócić.",
    "done": "Gotowe",
    "cancelledNotice": "Twój bieżący plan <strong>{{planName}}</strong> wygaśnie <strong>{{date}}</strong>. Odnów subskrypcję, aby nadal korzystać z naszych funkcji premium.",
    "resubscribedNotice": "Twój nowy plan <strong>{{planName}}</strong> rozpocznie się <strong>{{date}}</strong>, gdy wygaśnie bieżący."
  },
  "tdAccount": {
    "title": "Konto Tobii Dynavox",
    "header": "Co to jest konto Tobii Dynavox jednokrotnego logowania (SSO)?",
    "body": "Twoje konto Tobii Dynavox jednokrotnego logowania, składające się z adresu e-mail i hasła, pozwala logować się we wszystkich naszych witrynach i aplikacjach. Oprócz ulepszonych funkcji bezpieczeństwa, funkcja SSO zapewnia szybszy i wygodniejszy dostęp do zawartości we wszystkich usługach Tobii Dynavox.",
    "haveA": "Masz",
    "tobiiDynavoxAccount": "konto Tobii Dynavox?"
  },
  "redirectPageTitle": {
    "homePage": "Strona główna",
    "profileCreation": "Tworzenie profilu"
  },
  "download": {
    "downloadBoardmaker": "Pobierz Boardmaker",
    "downloadBoardmakerStudentCenter": "Pobierz Boardmaker Student Center",
    "downloadOtherVersions": "Pobierz inne wersje oprogramowania",
    "downloadBoardmakerStudio": "Pobierz Boardmaker Studio",
    "licenseKey": "Klucz licencyjny",
    "download": "Pobierz",
    "licenseHelper": "Pomoc ws. licencji",
    "discontinued": "Przerwano dostęp do konta <1>{{discontinueDate}}</1>. Patrz <3>wymagania systemowe</3>.",
    "mainFeatures": "Główne funkcje",
    "compatibility": "Kompatybilność",
    "improvements": "Ulepszenia",
    "bugFixes": "Poprawki błędów",
    "version": "Wersja",
    "discontinuedSupport": "Wycofane wsparcie",
    "releaseDate": "Opublikowano {{date}}",
    "discontinuedDate": "Wycofano {{date}}",
    "boardmakerSummary": "Kliknij poniższy przycisk, aby pobrać najnowszą wersję oprogramowania Boardmaker Editor, służącego do tworzenia i edytowania ćwiczeń.  Instalator działa w przypadku wszystkich rodzajów konta i obsługiwanych języków.",
    "studentCenterSummary": "Kliknij poniższy przycisk, aby pobrać najnowszą wersję oprogramowania Boardmaker Student Center, służącego do odtwarzania ćwiczeń Boardmaker. Instalator działa w przypadku wszystkich rodzajów konta i obsługiwanych języków.",
    "boardmakerIntro": "Boardmaker 7 Editor to najlepsze narzędzie, które pomaga wychowawcom, terapeutom i rodzicom tworzyć, edytować i udostępniać ćwiczenia Boardmaker.  Wspieraj naukę i komunikację w klasie, gabinecie terapeutycznym lub w domu dzięki bogactwu materiałów, które można dostosować do indywidualnych potrzeb.",
"studentCenterIntro": "W połączeniu z niektórymi rodzajami subskrypcji Boardmaker 7, nauczyciele mogą przypisywać aktywności uczniom w aplikacji Boardmaker 7 Student Center i śledzić ich postępy.  Uczniowie mogą korzystać z aplikacji w domu lub w szkole, aby ukończyć swoje aktywności.",
"boardmakerStudioIntro": "Boardmaker Studio pozwala osobom wspierającym uczniów z niepełnosprawnościami tworzyć i edytować aktywności, aby pomóc uczniom w nauce i komunikacji za pomocą symboli, tekstu oraz mowy syntetycznej i nagranej.",
"mobilePlayerIntro": "W połączeniu z niektórymi rodzajami subskrypcji myBoardmaker, nauczyciele mogą przypisywać aktywności uczniom w aplikacji Boardmaker Student Center i śledzić ich postępy.  Uczniowie mogą korzystać z aplikacji w domu lub w szkole, aby ukończyć swoje aktywności.",
    "communityStartHeader": [
      "Uzyskaj dostęp do społeczności i magazynu danych",
      0,
      0
    ],
    "communityStartBody": [
      "Boardmaker zaprojektowano do pracy z witryną Boardmakeronline.com, w której można bezpiecznie utworzyć kopię zapasową prywatnych plików Boardmaker i uzyskać dostęp do globalnej społeczności. Członkowie społeczności mogą udostępniać własne materiały i wyszukiwać nowe ćwiczenia Boardmaker od innych użytkowników. Załóż bezpłatne konto, aby dołączyć do społeczności!",
      0,
      0
    ],
    "latestMobile": "Dla uzyskania najlepszych efektów spróbuj pobrać oprogramowanie za pomocą urządzenia, które jest zgodne z <1>{{systemRequirements}}</1>.",
    "downloadSystemRequirements": "wymagania systemowe",
    "viewSystemRequirements": "Przejdź do <1>{{guideLink}}</1>, aby zobaczyć wymagania systemowe.",
    "onThisPage": "Na tej stronie",
    "communityStart": {
      "header": "Uzyskaj dostęp do społeczności i magazynu danych",
      "body": "Boardmaker jest przeznaczony do współpracy z witryną myboardmaker.com. Bezpłatne konto społeczności Boardmaker obejmuje:",
      "pointOne": "Magazyn danych w chmurze — utwórz bezpieczną kopię prywatnych plików Boardmaker i uzyskuj do nich dostęp z każdego miejsca!",
      "pointTwo": "Activities-to-Go - uporządkowany wg stopnia trudności i zagadnień program nauki, gotowy do druku i użycia.",
      "pointThree": "Dostęp do naszej globalnej społeczności — udostępniaj własne materiały i wyszukuj nowe ćwiczenia Boardmaker utworzone przez innych użytkowników.",
      "footer": "Załóż bezpłatne konto, aby dołączyć do społeczności!"
    },
    "BoardmakerCompatible": "To urządzenie nie jest zgodne z oprogramowaniem Boardmaker.",
    "BoardmakerStudentCenterCompatible": "To urządzenie nie jest zgodne z oprogramowaniem Boardmaker Student Center Application.",
    "BoardmakerMobile": "To urządzenie nie obsługuje aplikacji Boardmaker."
  },
  "subscriptionLicense": {
    "toggle": {
      "subscription": "subskrypcja",
      "tosubscriptionText": "$t(subscriptionLicense.toggle.subscription)",
      "license": "licencja",
      "tolicenseText": "zakup jednorazowy",
      "mainText": "Preferujesz <1>{{ toggleText }}</1> czy <3>{{ helpLink }}</3>?",
      "preferencedText": "Preferuję "
    },
    "comparison": {
      "accessTo": "Dostęp do następujących...",
      "title": "Pomóż mi wybrać",
      "titleDescription": "Szybki wgląd w różnice między subskrypcją myBoardmaker i oprogramowaniem Boardmaker.",
      "titles": {
        "investment": "Inwestycja",
        "includedSoftware": "Dołączone oprogramowanie",
        "softwareUpdates": "Aktualizacje oprogramowania",
        "pcsSymbols": "PCS Symbols",
        "cloudStorage": "Przechowywanie danych w chmurze",
        "curriculum": "Program",
        "studentManagement": "Zarządzanie uczniami"
      },
      "subscription": {
        "header": "Subskrypcja myBoardmaker",
        "investment": "Niska płatność z góry, opcje płatności rocznej lub miesięcznej",
        "includedSoftware": "Boardmaker 7, Boardmaker Student Center",
        "softwareUpdates": "Dołączone (2-3 razy na rok)",
        "pcsSymbols": "Wszystkie symbole, w tym nowe symbole co 2 tygodnie",
        "cloudStorage": ["Zbiór ćwiczeń", "Magazyn multimediów"],
        "curriculum": [
          "10 tematów Boardmaker Activities to Go x 4 jednostki każdy",
          "Reading Avenue",
          "Core First Learning",
          "Expedition Education",
          "Book Bridge"
        ],
        "studentManagement": [
          "Przydzielanie ćwiczeń\u00B9",
          "Śledzenie wyników"
        ]
      },
      "license": {
        "header": "Tylko oprogramowanie",
        "investment": "Jednorazowy zakup oprogramowania",
        "includedSoftware": "Boardmaker 7",
        "softwareUpdates": "Okresowe płatne aktualizacje (co 2-3 lata)",
        "pcsSymbols": "Wszystkie symbole dostępne w chwili udostępnienia najnowszej wersji (subskrypcja PCS już wkrótce)",
        "cloudStorage": "Zbiór ćwiczeń",
        "curriculum": "1 temat Boardmaker Activities to Go x 4 jednostki każdy",
        "studentManagement": "Brak"
      },
      "note": "Użytkownicy mogą zarządzać zadaniami i dodawać nowe do poszczególnych uczniów w planie Subskrypcji profesjonalisty",
      "note2": "Dostęp można uzyskać tylko za pomocą Student Center Player",
      "note3": "Użytkownicy mogą zarządzać zadaniami i dodawać nowe do poszczególnych uczniów w planie Subskrypcji profesjonalisty",
      "localizationNoteOne": "Aplikacje Boardmaker 7 są dostępne w następujących wersjach językowych dla użytkowników subskrypcji i dożywotnich (tylko oprogramowanie)",
      "availableIn": [
        "Dansk",
        "Deutsch",
        "English (US)",
        "Español",
        "Suomi",
        "Français",
        "Italiano",
        "Norsk",
        "Polski",
        "Português (Brasil)",
        "Русский",
        "Svenska"
      ],
      "oldAvailableIn": [
        "Angielski (USA)",
        "Hiszpański",
        "Niemiecki",
        "Szwedzki",
        "Fiński",
        "Rosyjski",
        "Duński",
        "Norweski",
        "Francuski",
        "Włoski",
        "Polski",
        "Portugalski"
      ],
      "localizationNoteTwo": "Program nauczania i witryna myBoardmaker.com są dostępne tylko w języku angielskim."
    }
  },
  "systemRequirements": "Wymagania systemowe",
  "releaseNotes": "Przegląd informacji o wersji",
  "operatingSystem": {
    "title": "System operacyjny",
    "macos": "macOS",
    "chromebook": "Chromebook",
    "ios": "iPadOS",
    "android": "Android (urządzenia mobilne)",
    "windows": "Windows",
    "unknown": "Nieznany"
  },
  "perpetual": {
    "trial": {
      "intro": "Karta kredytowa nie jest wymagana. Bez zobowiązań. Pozostało tylko <1>{{trialLength}}</1> kolejnych dni nieograniczonego dostępu do naszego najnowszego programu Boardmaker. Po pobraniu i zainstalowaniu programu na komputerze możesz poprosić o <3>{{trialLength}}</3>-dniowy klucz aktywacyjny<5>*</5> za pomocą programu.",
      "footnote": "<0>*</0>Wersje próbne rozpoczynają się w dniu aktywacji naszego oprogramowania i pozostaną aktywne przez <2>{{trialLength}}</2> dni.",
      "downloadFootnote": "<0>v{{version}}</0> obejmuje najnowsze funkcje i poprawki. Patrz <2>wymagania systemowe</2>."
    },
    "thankyou": {
      "intro": "Znajdź wiadomość e-mail z potwierdzeniem, zawierającą łącza do pobrania plików i klucz aktywacyjny Boardmaker. Informacje te zostały również zawarte poniżej. Pobierz i zainstaluj Boardmaker na swoim komputerze, a następnie użyj klucza aktywacyjnego do aktywacji oprogramowania. Po zakończeniu aktywacji otrzymasz roczny dostęp do aktualizacji. <1>Zachowaj klucz aktywacyjny na przyszłość.</1>"
    },
    "latest": "Najnowsze",
    "legacy": "Starsze"
  },
  "countries": {
    "us": "Stany Zjednoczone"
  },
  "currencyChange": {
    "header": "Zmiana waluty",
    "body": "W obecnej chwili subskrypcji nie można opłacić za pomocą waluty z wybranego kraju. Kontynuowanie spowoduje zmianę obecnej waluty na dolary amerykańskie (USD)."
  },
  "partner": {
    "body": "We wszystkich sprawach związanych z produktem i zagadnieniami technicznymi prosimy kontaktować się z wybranym partnerem lub dostawcą pomocy technicznej, który będzie główną osobą kontaktową.",
    "contactUs": "Jeśli wybrany kraj nie jest prawidłowy, prosimy ",
    "contactCustomerService": "skontaktować się z działem obsługi klienta."
  }
}
